import { isValidNanpDigits, nanpDigits } from '@/lib/validation/phone';
import { z } from 'zod';

export const createProfileSchema = z.object({
  firstName: z.string().trim().min(2, 'First name is required'),
  lastName: z.string().trim().min(2, 'Last name is required'),
  phone: z
    .string()
    .trim()
    .superRefine((val, ctx) => {
      const d = nanpDigits(val);
      if (!isValidNanpDigits(d)) {
        ctx.addIssue({
          code: 'custom',
          message: 'Enter a valid North American phone number',
        });
      }
    }),
  country: z.enum(['US', 'CA'], { message: 'Country is required' }),
  addressLine1: z.string().trim().min(4, 'Address is required'),
  addressLine2: z.string().trim().optional(),
  city: z.string().trim().min(2, 'City is required'),
  region: z.string().trim().min(2, 'State/Province is required'),
  postalCode: z.string().trim().min(3, 'Postal/ZIP code is required'),
});

export type CreateProfileFormValues = z.infer<typeof createProfileSchema>;
export type ProfileFieldErrors = Partial<Record<keyof CreateProfileFormValues, string>>;

export function toProfileFieldErrors(error: z.ZodError): ProfileFieldErrors {
  const out: ProfileFieldErrors = {};

  for (const issue of error.issues) {
    const key = issue.path[0] as keyof CreateProfileFormValues | undefined;
    if (!key) continue;
    if (!out[key]) out[key] = issue.message;
  }

  return out;
}
